<template>
  <e-charts
    ref="line"
    autoresize
    :option="option"
    theme="theme-color"
    auto-resize
    :update-options="{notMerge:true}"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import { ref, toRef, watch } from '@vue/composition-api'
import { registerTheme, use } from 'echarts/core'
import {
  BarChart, LineChart, LinesChart, PieChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  LegendScrollComponent, MarkLineComponent, MarkPointComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components'
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'
import { format, parse } from 'date-fns'
import ptBrLocale from 'date-fns/locale/pt-BR'
import { roundTripArray } from '@core/utils/utils'
import theme from '../theme.json'

use([
  BarChart,
  LineChart,
  PieChart,
  LinesChart,
  LegendScrollComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
])
registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    mobile: {
      type: Object,
      default: () => ({ mobile: false }),
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const chartData = toRef(props, 'chartData')
    // const mobile = toRef(props, 'mobile')

    const option = ref({
      title: {
        text: 'Evolução das vendas mensais',
        subtext: 'Apresenta a evolução das vendas mensais de forma linear',
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [],
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}mil',
        },
        axisPointer: {
          snap: true,
        },
      },
      visualMap: null,
      series: [
        {
          name: 'Vendas',
          type: 'line',
          smooth: true,
          data: null,
        },
        {
          name: 'Tendência',
          type: 'line',
          showSymbol: false,
          lineStyle: {
            color: '#8e8e9a',
            type: 'dashed',
            width: 1,
          },
          data: [],
        },
      ],
    })

    watch(chartData, data => {
      if (!Object.keys(data).length) return
      /*
         "aa3a3b5d-5f47-46b6-9e60-494eb42f0a98": {
               "total_year": {
                   "2023": 1599725
               },
               "total_year_percentage": {
                   "2023": 0
               },
               "average_year": {
                   "2023": 133310.41666666666
               },
               "average_year_percentage": {
                   "2023": 0
               },
               "value_month": {
                   "2023": {
                       "1": 1000,
                       "2": 1158000,
                       "3": 356000,
                       "4": 0,
                   },
                   "2024": {
                       "1": 0,
                       "2": 0,
                       "3": 0,
                       "4": 0
                   }
               },
               "value_month_percentage": {
                   "2023": {
                       "1": 0,
                       "2": 0,
                       "3": 0,
                       "4": 0,
                   },
                   "2024": {
                       "1": -100,
                       "2": -100,
                       "3": -100,
                       "4": 0
                   }
               },
               "trendline": {
                   "1": 307996.13970588235,
                   "2": 280261.0294117647,
                   "3": 252525.91911764705,
                   "4": 224790.8088235294,
                   "5": 197055.69852941178,
                   "6": 169320.58823529413,
               }
           }
         * */
      const colors = theme.color
      const seriesData = []
      const xAxisData = []
      const piecesData = {}

      const institution = data[Object.keys(data)[0]]
      const years = Object.keys(institution.value_month).sort()
      let monthIndex = 0
      years.forEach((year, index) => {
        piecesData[year] = {
          gt: monthIndex,
          lte: 0,
          color: roundTripArray(colors, index),
        }
        Object.keys(institution.value_month[year]).forEach(month => {
          monthIndex += 1
          piecesData[year].lte = monthIndex
          const monthYear = `${year}-${month}`
          const date = parse(monthYear, 'yyyy-MM', new Date())
          xAxisData.push(format(date, 'MMM/yy', { locale: ptBrLocale }))
          const price = institution.value_month[year][month] / 100
          seriesData.push(price)
        })
      })

      option.value.xAxis.data = xAxisData
      option.value.series[0].data = seriesData
      option.value.series[1].data = Object.values(institution.trendline).map(n => Math.round(n / 100))
      option.value.visualMap = {
        show: false,
        dimension: 0,
        pieces: Object.values(piecesData),
      }
    })

    return {
      option,
    }
  },
}
</script>
